export const LOAD_TASK_BY_ID = 'LOAD_TASK_BY_ID';
export const GET_DYNAMIC_FIELDS = 'GET_DYNAMIC_FIELDS';
export const GET_PROJECT_LIST = 'GET_PROJECT_LIST';
export const ADD_NEW_PROJECT = 'ADD_NEW_PROJECT';
export const GET_TASK_BY_ID = 'GET_TASK_BY_ID';
export const GET_PAINT_LIST = 'GET_PAINT_LIST';
export const GET_HTML_PRE_VIEW = 'GET_HTML_PRE_VIEW';
export const ARCHIVE_TASK = 'ARCHIVE_TASK';
export const GET_COMMENTS_LIST = 'GET_COMMENTS_LIST';
export const GET_SALES_PERSONS_LIST = 'GET_SALES_PERSONS_LIST';
export const ADD_COMMENT = 'ADD_COMMENT';
export const GET_HISTORY_POSITION = 'GET_HISTORY_POSITION';
export const GET_HISTORY_STATUS = 'GET_HISTORY_STATUS';
export const GET_HISTORY_CREATED = 'GET_HISTORY_CREATED';
export const GET_HISTORY_UPDATE = 'GET_HISTORY_UPDATE';
export const GET_HISTORY_VIEW = 'GET_HISTORY_VIEW';
export const SET_PROJECT_ATTACHMENTS = 'SET_PROJECT_ATTACHMENTS';
export const DELETE_ATTACHMENT = 'DELETE_ATTACHMENT';
export const DELETE_TASKS_BY_IDS = 'DELETE_TASKS_BY_IDS';
export const DELETE_TASK_BY_ID = 'DELETE_TASK_BY_ID';
export const SEND_SUPPLIER_EMAIL = 'SEND_SUPPLIER_EMAIL';

export function sendSupplierEmail(vendor) {
  return {
    type: SEND_SUPPLIER_EMAIL,
    payload: vendor,
  }
}

export function setTaskAttachments(data) {
  return {
    type: SET_PROJECT_ATTACHMENTS,
    payload: data,
  }
}

export function getTaskByID(data) {
  return {
    type: GET_TASK_BY_ID,
    payload: data,
  }
}

export function getPaintList(data) {
  return {
    type: GET_PAINT_LIST,
    payload: data,
  }
}

export function getSalesPersonsList(data) {
  return {
    type: GET_SALES_PERSONS_LIST,
    payload: data,
  }
}

export function getPreViewHtml(data) {
  return {
    type: GET_HTML_PRE_VIEW,
    payload: data,
  }
}

export function loadTaskById(data) {
  return {
    type: LOAD_TASK_BY_ID,
    payload: data,
  }
}

export function getDynamicFields(data) {
  return {
    type: GET_DYNAMIC_FIELDS,
    payload: data,
  }
}

export function getProjectsList(data) {
  return {
    type: GET_PROJECT_LIST,
    payload: data,
  }
}

export function addNewWO(data) {
  return {
    type: ADD_NEW_PROJECT,
    payload: data,
  }
}

export function archiveTask(data) {
  return {
    type: ARCHIVE_TASK,
    payload: data,
  }
}

export function getCommentsList(data) {
  return {
    type: GET_COMMENTS_LIST,
    payload: data,
  }
}

export function addComment(data) {
  return {
    type: ADD_COMMENT,
    payload: data,
  }
}

export function actionGetHistoryPosition(data) {
  return {
    type: GET_HISTORY_POSITION,
    payload: data,
  }
}

export function actionGetHistoryStatus(data) {
  return {
    type: GET_HISTORY_STATUS,
    payload: data,
  }
}

export function actionGetHistoryCreated(data) {
  return {
    type: GET_HISTORY_CREATED,
    payload: data,
  }
}

export function actionGetHistoryUpdated(data) {
  return {
    type: GET_HISTORY_UPDATE,
    payload: data,
  }
}

export function actionGetHistoryView(data) {
  return {
    type: GET_HISTORY_VIEW,
    payload: data,
  }
}

export function actionDeleteAttachment(data) {
  return {
    type: DELETE_ATTACHMENT,
    payload: data,
  }
}

export function deleteTasksByIds(data) {
    return {
        type: DELETE_TASKS_BY_IDS,
        payload: data,
    }
}

export function deleteTaskById(data) {
  return {
    type: DELETE_TASK_BY_ID,
    payload: data,
  }
}



// WEBPACK FOOTER //
// ./src/actions/tasks/index.js